import generateBlockId from './generate-block-id';
import getUsedBlocksFromHTML from './get-used-blocks-from-html';
import getElementsToBeReplaced from './get-elements-to-be-replaced';

export default {
  generateBlockId,
  getUsedBlocksFromHTML,
  getElementsToBeReplaced,
};
